// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.th-inner.sortable.both {
  font-size: 9pt;
  font-weight: bold;
}

#table {
  font-size: 9pt !important;
}

input[class*='form-control bootstrap-table-filter-control'] {
  font-size: 9pt !important;
}

td {
  padding: 3px !important;
  line-height: 16px !important;
  background-color: #fdfdfd !important;
}

.form-control {
  margin-bottom: 3px !important;
}

.multi-sort.btn.btn-default {
  visibility: hidden;
}

.columns.columns-right.btn-group.float-right {
  height: 0px !important;
}

.content-article {
  width: 1140px !important;
}
`, "",{"version":3,"sources":["webpack://./css/metadata.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".th-inner.sortable.both {\n  font-size: 9pt;\n  font-weight: bold;\n}\n\n#table {\n  font-size: 9pt !important;\n}\n\ninput[class*='form-control bootstrap-table-filter-control'] {\n  font-size: 9pt !important;\n}\n\ntd {\n  padding: 3px !important;\n  line-height: 16px !important;\n  background-color: #fdfdfd !important;\n}\n\n.form-control {\n  margin-bottom: 3px !important;\n}\n\n.multi-sort.btn.btn-default {\n  visibility: hidden;\n}\n\n.columns.columns-right.btn-group.float-right {\n  height: 0px !important;\n}\n\n.content-article {\n  width: 1140px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
